import React from 'react';
import '../News/DeleteNew/DeleteNew.scss';
import { useDispatch } from 'react-redux';
import { deleteCLient } from '../../../api/ClientApi/ClientApi.js';
import { useNavigate } from 'react-router-dom';

const DeleteCLient = ({ showWarning, setShowWarning, id }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(deleteCLient(id));
    // console.log(id);
    navigate('/wcmPartners');
    setShowWarning(!showWarning);
  };
  return (
    <div className={`${showWarning ? 'warning' : 'hidden'} `}>
      <div className="war-header">
        <p>Confirm Delete</p>
      </div>
      <div className="bottom">
        <div>
          <p>Are You Sure You Want Delete this?</p>
        </div>
        <div className="btns">
          <button onClick={handleDelete}>Yes</button>
          <button onClick={() => setShowWarning(!showWarning)}>No</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCLient;
